export const patients = '/patients';
export const patientUrl = (id: string) => `/patients/${id}`;
export const patientDeleteUrl = (id: string) => `/patients/${id}/delete`;
export const download = 'patients/download';
